import { observable, action } from 'mobx';
import api from 'core/util/api';
import McpServerCollection from './McpServerCollection';

const STATUS_COOLDOWN_MS = 60000;

class McpServerStore {
  collection = new McpServerCollection();

  @observable statusMap = new Map();

  lastStatusFetchAt = 0;

  @action
  checkAllStatuses = (opts = {}) => {
    const models = this.collection.get();

    if (models.length === 0) {
      return;
    }

    if (!opts.force && Date.now() - this.lastStatusFetchAt < STATUS_COOLDOWN_MS) {
      return;
    }

    this.lastStatusFetchAt = Date.now();

    // Clean stale entries for servers no longer in collection
    const currentIds = new Set(models.map((m) => m.get('id')));

    for (const key of this.statusMap.keys()) {
      if (!currentIds.has(key)) {
        this.statusMap.delete(key);
      }
    }

    models.forEach((model) => {
      const id = model.get('id');
      this.statusMap.set(id, { loading: true, connected: false, error: null });
      api
        .get(`/api/ui/ai/mcp-servers/${id}/status`)
        .then(
          action((result) => {
            this.statusMap.set(id, { loading: false, ...result });
          })
        )
        .catch(
          action(() => {
            this.statusMap.set(id, { loading: false, connected: false, error: 'Request failed' });
          })
        );
    });
  };
}

export default new McpServerStore();
